<template>
  <div class="admin">
    <div class="fluid-container">
      <div class="row no-gutters">
        <!-- menu admin -->
        <div class="col-3">
          <menu-admin></menu-admin>
        </div>
        <!-- menu admin -->

        <!-- main -->
        <div class="col-9 main pb-5">
          <div class="row">
            <div class="col-12 mb-2">
              <div class="title-admin">
                <h1 class="display-3 font-weight-black">Editar gasto</h1>
                <div class="acciones">
                  <v-btn large color="primary" to="/admin/agregar-gasto">
                    <v-icon class="mr-3">add</v-icon>Agregar gasto
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12">
              <v-textarea
                outlined
                v-model="descripcion"
                auto-grow
                label="Descripción del gasto"
              ></v-textarea>

              <div class="row">
                <div class="col" style="padding-left: 0">
                  <v-text-field
                    label="Monto"
                    placeholder="$"
                    outlined
                    v-model="monto"
                  />
                </div>

                <div class="col" style="padding-right: 0">
                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="fecha"
                    persistent
                    full-width
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="fecha"
                        label="Fecha"
                        prepend-icon="event"
                        readonly
                        outlined
                        background-color="#ffffff"
                        v-on="on"
                      ></v-text-field>
                    </template>

                    <v-date-picker v-model="fecha">
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog.save(fecha)"
                        >OK</v-btn
                      >
                      <v-btn text color="primary" @click="modal = false"
                        >Cancelar</v-btn
                      >
                    </v-date-picker>
                  </v-dialog>
                </div>
              </div>

              <v-btn large color="primary" @click="validar()"
                >Agregar gasto</v-btn
              >
              <v-btn class="ml-3" large color="red" dark @click="showAlert()"
                >Eliminar gasto</v-btn
              >
            </div>
          </div>
        </div>
        <!-- /main -->
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
const axios = require("axios");
import router from "@/router";
export default {
  components: { DatePicker },
  data() {
    return {
      fecha: "",
      monto: "",
      descripcion: "",
      loader: false,
      id_gasto: this.$route.params.id,
    };
  },
  methods: {
    validar() {
      if (this.descripcion == "") {
        this.$swal({
          type: "error",
          customClass: "arriba",
          title: "Selecciona la descripción del gasto",
          showConfirmButton: true,
        });
      } else if (this.monto == "") {
        this.$swal({
          type: "error",
          customClass: "arriba",
          title: "Selecciona el monto del gasto",
          showConfirmButton: true,
        });
      } else if (this.fecha == "") {
        this.$swal({
          type: "error",
          customClass: "arriba",
          title: "Selecciona la fecha del gasto",
          showConfirmButton: true,
        });
      } else {
        //Los datos requeridos se ingresaron
        this.guardar();
      }
    },

    getGastoData() {
      //Obtenemos los datos del gasto
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getGastoData&id=" +
            this.id_gasto
        )
        .then((response) => {
          this.descripcion = response.data.descripcion;
          this.monto = response.data.monto;
          this.fecha = response.data.fecha;
        })
        .catch((error) => console.log(error));
    },
    eliminarGasto() {
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=deleteGasto&id=" +
            this.id_gasto
        )
        .then((response) => {
          this.$swal({
            type: "success",
            title: "El gasto se borró exitosamente",
            showConfirmButton: false,
            timer: 1500,
          });

          setTimeout(
            () =>
              router.push({
                name: "gastos_admin",
              }),
            1500
          );
        })
        .catch((error) => console.log(error));
    },
    showAlert() {
      // Use sweetalert2
      this.$swal({
        title: "Estás seguro que deseas eliminar el gasto",
        text: "No podrás deshacer este cambio!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, estoy seguro!",
        cancelButtonText: "No!",
      }).then((result) => {
        if (result.value) {
          //Enviamos petición al servidor
          this.eliminarGasto();
        }
      });
    },
    guardar() {
      this.loader = true;
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=updateGasto" +
            "&descripcion=" +
            this.descripcion +
            "&monto=" +
            this.monto +
            "&fecha=" +
            this.fecha +
            "&id=" +
            this.id_gasto
        )
        .then((response) => {
          this.loader = false;

          //Mostramos notificación
          this.$swal({
            type: "success",
            title: "El gasto se actualizó exitosamente",
            showConfirmButton: true,
          });
        })
        .catch((error) => console.log(error));
    },
  },
  mounted() {
    this.getGastoData();
  },
};
</script>
